export default (function () {
  let storage = typeof localStorage === 'undefined' ? {} : localStorage;

  return {
    set(name, value) {
      value = JSON.stringify(value);
      storage[name] = value;
      return value;
    },
    get(name) {
      let value = storage[name];
      if (value === undefined || typeof window === 'undefined') {
        return undefined;
      }

      try {
        value = JSON.parse(value);
      } catch (e) {
        value = undefined;
      }
      return value;
    },
    clear() {
      try {
        storage.clear();
      } catch (e) {
        storage = {};
      }
    },
    remove(name) {
      storage[name] = undefined;
    }
  };

})();



// WEBPACK FOOTER //
// ./services/safe-local-storage.js